import { PANEL_SIZE } from '../config.js';

function inBounds([x, y]) {
  return x >= 0 && x <= PANEL_SIZE && y >= 0 && y <= PANEL_SIZE;
}

function assert(cond, msg) {
  if (!cond) throw new Error(msg);
}

export function validateLevel(level) {
  assert(level && typeof level === 'object', 'level must be an object');
  assert(typeof level.id === 'number', 'level.id is required (number)');
  assert(typeof level.name === 'string', 'level.name is required (string)');
  assert(Array.isArray(level.start) && level.start.length === 2, 'level.start is required ([x, y])');
  assert(Array.isArray(level.goal) && level.goal.length === 2, 'level.goal is required ([x, y])');
  assert(inBounds(level.start), `level.start out of bounds: ${JSON.stringify(level.start)}`);
  assert(inBounds(level.goal), `level.goal out of bounds: ${JSON.stringify(level.goal)}`);
  assert(Array.isArray(level.holes), 'level.holes must be an array');
  for (const h of level.holes) {
    assert(Array.isArray(h) && h.length === 2, 'hole must be [x, y]');
    assert(inBounds(h), `hole out of bounds: ${JSON.stringify(h)}`);
  }
  assert(Array.isArray(level.walls), 'level.walls must be an array');
  for (const w of level.walls) {
    assert(w && Array.isArray(w.from) && Array.isArray(w.to), 'wall must have from/to arrays');
    assert(inBounds(w.from) && inBounds(w.to), `wall endpoint out of bounds: ${JSON.stringify(w)}`);
  }
}

export class LevelLoader {
  /**
   * @param {number} id — level id (1, 2, 3)
   * @returns {Promise<object>} validated level data
   */
  async load(id) {
    const url = `levels/level-${id}.json`;
    let res;
    try {
      res = await fetch(url);
    } catch (e) {
      throw new Error(`failed to fetch ${url}: ${e.message}`);
    }
    if (!res.ok) {
      throw new Error(`failed to fetch ${url}: HTTP ${res.status}`);
    }
    const data = await res.json();
    validateLevel(data);
    return data;
  }
}
